import React, { useState, useEffect } from "react";
import { Table, Pagination } from "react-bootstrap";
import axiosClient from "../../axios";
import { Link } from "react-router-dom";

const USERS_PER_PAGE = 2;

const Users = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortedAsc, setSortedAsc] = useState(true);
  const [totalPages, setTotalPages] = useState(0);

  // Fetch users from the Laravel API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosClient.get(
          `/api/users?page=${currentPage}`,
        );
        setUsers(response.data.data);
        setTotalPages(response.data.last_page);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, [currentPage]);

  // Sort users by registration time
  const sortedUsers = [...users].sort((a, b) =>
    sortedAsc
      ? new Date(a.created_at) - new Date(b.created_at)
      : new Date(b.created_at) - new Date(a.created_at),
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <h3 className="mb-4">Users</h3>
      <Table striped bordered hover>
        <thead className="table-success">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Role</th>
            <th>Subscription</th>
            <th>phone</th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => setSortedAsc(!sortedAsc)}
            >
              Registration Time
              {sortedAsc ? " 🔼" : " 🔽"}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map((user, index) => (
            <tr key={user.id}>
              <td>{(currentPage - 1) * USERS_PER_PAGE + index + 1}</td>
              <td>
                <Link to={`/xl-admin/users/${user.id}`}>{user.name}</Link>
              </td>
              <td>{user.role}</td>
              <td>{user.premium === 1 ? "Yes" : "No"}</td>
              <td>{user.phone}</td>
              <td>{new Date(user.created_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination>
        {[...Array(totalPages).keys()].map((num) => (
          <Pagination.Item
            key={num + 1}
            active={num + 1 === currentPage}
            onClick={() => paginate(num + 1)}
          >
            {num + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </div>
  );
};

export default Users;
